import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

export const { fieldContext, formContext, useFieldContext } =
  createFormHookContexts();

/**
 * The app's form hook. `useAppForm` replaces `useForm`; `withForm` is what lets
 * a large form be split into pieces that each receive the *typed form itself*
 * instead of a long list of its values — see the card generator's steps.
 *
 * No bound field or form components are registered: our inputs are too
 * different from one another to share a wrapper, and a component that only
 * needs one field can take it through `form.Field` as before.
 */
export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {},
  formComponents: {},
});
